/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Chargers Transaction properties that can be used for sorting.
 */
export var ChargerTransactionPropertiesForSorting;
(function (ChargerTransactionPropertiesForSorting) {
    ChargerTransactionPropertiesForSorting["TRANSACTION_ID"] = "transactionId";
    ChargerTransactionPropertiesForSorting["CONNECTOR_ID"] = "connectorId";
    ChargerTransactionPropertiesForSorting["START_TIME"] = "startTime";
    ChargerTransactionPropertiesForSorting["END_TIME"] = "endTime";
    ChargerTransactionPropertiesForSorting["MAC_ID"] = "macId";
    ChargerTransactionPropertiesForSorting["INITIAL_SOC"] = "initialSoc";
    ChargerTransactionPropertiesForSorting["FINAL_SOC"] = "finalSoc";
    ChargerTransactionPropertiesForSorting["STOP_REASON"] = "stopReason";
    ChargerTransactionPropertiesForSorting["STOP_ACTOR"] = "stopActor";
})(ChargerTransactionPropertiesForSorting || (ChargerTransactionPropertiesForSorting = {}));
